import React from 'react';

const ToolTip = ({ children }) => (
  <div className="moca-table-tooltip">{children}</div>
);

export default ToolTip;
